var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState, memo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faPaperPlaneTop, } from "@fortawesome/pro-regular-svg-icons";
import { faPen, faStar, faTrash, faUndo, } from "@fortawesome/pro-solid-svg-icons";
import toast from "react-hot-toast";
import copy from "fast-copy";
// Import des hooks et types Redux
import { useAppSelector } from "@/hooks/store";
import { getCurrentUserDateFormat, getCurrentUserTimeFormat, } from "@/store/utils/selectors/userSelector";
// Import des mutations et queries
import { useCheckFavoriteQuery, useCreateFavoriteMutation, useDeleteRecordsMutation, useGetModuleBuilderLayoutListWidgetsQuery, useRemoveFavoriteMutation, useSaveRecordMutation, useSaveUploadedFileMutation, } from "@/store/api";
// Import des composants et utils
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import WidgetDisplay from "../widgetDisplay";
import { LayoutComponentDisplay } from "@/components/forms/components/layout/layoutComponentDisplay";
import { FieldViewType, screenViewType } from "@/components/fields/viewType";
import { LoaderImage } from "@/utils/loader";
import { useLogger } from "@/utils/loggerService";
import Subpanels from "./subpanels";
import { ReportsList } from "./aor_reports/detail/list";
import { ReportsChart } from "./aor_reports/detail/chart";
import "@/utils/validations/rules";
import { isEqual } from "lodash";
import { borderRadiusSubpanel } from "@/utils/funcs";
import { useValidation } from "@/utils/validations/useValidation";
import { usePopup } from "@/hooks/layout";
/*interface ValidationResult {
  [key: string]: string;
}*/
// Hook personnalisé pour la gestion des dates
var useDateTimeFormat = function (defaultFormat) {
    if (defaultFormat === void 0) { defaultFormat = "DD/MM/yyyy HH:mm"; }
    var dateFormat = useAppSelector(getCurrentUserDateFormat);
    var timeFormat = useAppSelector(getCurrentUserTimeFormat);
    return useMemo(function () { return "".concat(dateFormat, " ").concat(timeFormat) || defaultFormat; }, [dateFormat, timeFormat, defaultFormat]);
};
// Hook personnalisé pour la gestion des favoris
var useFavorites = function (module, recordId) {
    var _a = useState(false), favoriteFlag = _a[0], setFavoriteFlag = _a[1];
    var createFavoriteMutation = useCreateFavoriteMutation()[0];
    var removeFavoriteMutation = useRemoveFavoriteMutation()[0];
    var favoriteResponse = useCheckFavoriteQuery({
        params: {
            record_module: module,
            record_id: recordId,
        },
    }, { skip: !recordId }).data;
    useEffect(function () {
        var resp = (favoriteResponse === null || favoriteResponse === void 0 ? void 0 : favoriteResponse.data) || {};
        var ret = (resp === null || resp === void 0 ? void 0 : resp.return) || {};
        ret !== false && ret.length > 0 && setFavoriteFlag(true);
    }, [favoriteResponse]);
    var toggleFavorite = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!!favoriteFlag) return [3 /*break*/, 2];
                    return [4 /*yield*/, createFavoriteMutation({
                            body: { record_id: recordId, record_module: module },
                        }).unwrap()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, removeFavoriteMutation({
                        body: { record_id: recordId, record_module: module },
                    }).unwrap()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setFavoriteFlag(!favoriteFlag);
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    toast.error("Error toggling favorite");
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [
        favoriteFlag,
        recordId,
        module,
        createFavoriteMutation,
        removeFavoriteMutation,
    ]);
    return { favoriteFlag: favoriteFlag, toggleFavorite: toggleFavorite };
};
var useRecord = function (initialRecord) {
    var _a = useState(copy(initialRecord)), editedRecord = _a[0], setEditedRecord = _a[1];
    var _b = useState(copy(initialRecord)), baseRecord = _b[0], setBaseRecord = _b[1];
    var _c = useState(false), isLoad = _c[0], setIsLoad = _c[1];
    var updateRecord = useCallback(function (edited) {
        setEditedRecord(edited);
    }, []);
    useEffect(function () {
        var cloned = copy(initialRecord);
        //setEditedRecord(initialRecord);
        setEditedRecord(cloned);
        setBaseRecord(cloned);
    }, [initialRecord]);
    var commitChanges = useCallback(function () {
        setBaseRecord(copy(editedRecord));
    }, [editedRecord]);
    var rollbackChanges = useCallback(function () {
        setEditedRecord(copy(baseRecord));
    }, [baseRecord]);
    return {
        editedRecord: editedRecord,
        updateRecord: updateRecord,
        isLoad: isLoad,
        setIsLoad: setIsLoad,
        baseRecord: baseRecord,
        commitChanges: commitChanges,
        rollbackChanges: rollbackChanges,
    };
};
var useSaveRecord = function (module, editedRecord, setIsLoad, validate) {
    var logger = useLogger().logger;
    var t = useTranslation(["common"]).t;
    var saveRecordMutation = useSaveRecordMutation()[0];
    var saveUploadedFileMutation = useSaveUploadedFileMutation()[0];
    var navigate = useNavigate();
    var saveUploadedFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var filebase, fileName, response, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    filebase = ((_a = editedRecord.filecontents) === null || _a === void 0 ? void 0 : _a.base64String) || "";
                    fileName = ((_b = editedRecord.filecontents) === null || _b === void 0 ? void 0 : _b.fileName) || "";
                    return [4 /*yield*/, saveUploadedFileMutation({
                            body: {
                                record: editedRecord,
                                filename: fileName,
                                fileuploaded: filebase,
                                remove: false,
                                module: module,
                            },
                        }).unwrap()];
                case 1:
                    response = _c.sent();
                    if (response === "ko") {
                        toast.error(t("app.LBL_FILE_SAVE_ERROR"));
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
                case 2:
                    error_2 = _c.sent();
                    logger.error("Upload file error:", error_2);
                    toast.error(t("app.LBL_FILE_SAVE_ERROR"));
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var saveRecord = function (sendInvites) {
        if (sendInvites === void 0) { sendInvites = 0; }
        return __awaiter(void 0, void 0, void 0, function () {
            var validationResult, uploadSuccess, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        validationResult = validate(editedRecord);
                        if (validationResult.size > 0) {
                            toast.error(t("app.LBL_FORM_VALIDATION_ERROR", { ns: "common" }) ||
                                "Veuillez corriger les erreurs du formulaire avant d'enregistrer.");
                            return [2 /*return*/, false];
                        }
                        setIsLoad(true);
                        if (!editedRecord.filecontents) return [3 /*break*/, 2];
                        return [4 /*yield*/, saveUploadedFile()];
                    case 1:
                        uploadSuccess = _a.sent();
                        if (!uploadSuccess) {
                            setIsLoad(false);
                            return [2 /*return*/, false];
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, saveRecordMutation({
                            body: { module: module, record: editedRecord, sendInvites: sendInvites },
                        }).unwrap()];
                    case 3:
                        _a.sent();
                        if (editedRecord.id) {
                            toast.success(t("app.LBL_RECORD_SAVED"));
                            setIsLoad(false);
                            return [2 /*return*/, true];
                        }
                        else {
                            navigate("/modules/".concat(module));
                            return [2 /*return*/, true];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        setIsLoad(false);
                        logger.error("Save error:", error_3);
                        toast.error(t("app.LBL_SAVE_ERROR"));
                        return [2 /*return*/, false];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return { saveRecord: saveRecord };
};
// Composant principal avec typage
var ModuleDetail = memo(function (_a) {
    var widget = _a.widget;
    var t = useTranslation(["common", "Home"]).t;
    var navigate = useNavigate();
    var _b = (widget === null || widget === void 0 ? void 0 : widget.payload) || {}, _c = _b.module, module = _c === void 0 ? "" : _c, _d = _b.view_defs, layoutMeta = _d === void 0 ? { layout: [] } : _d, _e = _b.field_defs, field_defs = _e === void 0 ? {} : _e, _f = _b.record, record = _f === void 0 ? {} : _f, _g = _b.isPreview, isPreview = _g === void 0 ? false : _g, _h = _b.view, view = _h === void 0 ? screenViewType.EDITVIEW : _h;
    var dateTimeFormat = useDateTimeFormat();
    var _j = useFavorites(module, record === null || record === void 0 ? void 0 : record.id), favoriteFlag = _j.favoriteFlag, toggleFavorite = _j.toggleFavorite;
    var _k = useRecord(record), editedRecord = _k.editedRecord, updateRecord = _k.updateRecord, isLoad = _k.isLoad, setIsLoad = _k.setIsLoad, baseRecord = _k.baseRecord, commitChanges = _k.commitChanges, rollbackChanges = _k.rollbackChanges;
    var _l = useValidation(layoutMeta, field_defs), validations = _l.validations, validate = _l.validate, filteredFieldsDefs = _l.filteredFieldsDefs, resetValidations = _l.resetValidations;
    useEffect(function () {
        if (validations.size > 0) {
            validate(editedRecord);
        }
    }, [editedRecord]);
    var saveRecord = useSaveRecord(module, editedRecord, setIsLoad, validate).saveRecord; //Validations sur detail view
    var elemId = isPreview ? "previewDetailForm" : "detailForm";
    // Gestionnaire des raccourcis clavier
    /*useEffect(() => {
      const keyPressSave = ({ key }: KeyboardEvent) => {
        if (key === "Enter") saveRecord();
      };
  
      window.addEventListener("keypress", keyPressSave);
      return () => window.removeEventListener("keypress", keyPressSave);
    }, [saveRecord]);*/
    var _m = useState(0), formVersion = _m[0], setFormVersion = _m[1];
    var handleSave = function (sendInvites) {
        if (sendInvites === void 0) { sendInvites = 0; }
        return __awaiter(void 0, void 0, void 0, function () {
            var validationResult, success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validationResult = validate(editedRecord);
                        if (validationResult.size > 0) {
                            toast.error(t("app.LBL_FORM_VALIDATION_ERROR", { ns: "common" }) ||
                                "Veuillez corriger les erreurs du formulaire avant d'enregistrer.");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, saveRecord(sendInvites)];
                    case 1:
                        success = _a.sent();
                        if (success) {
                            setFormVersion(function (v) { return v + 1; });
                            commitChanges === null || commitChanges === void 0 ? void 0 : commitChanges();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        var keyPressSave = function (_a) {
            var key = _a.key;
            if (key === "Enter")
                handleSave(); // ✅
        };
        window.addEventListener("keypress", keyPressSave);
        return function () { return window.removeEventListener("keypress", keyPressSave); };
    }, [handleSave]);
    var handleRollback = function () {
        rollbackChanges === null || rollbackChanges === void 0 ? void 0 : rollbackChanges();
        resetValidations();
        setFormVersion(function (v) { return v + 1; });
    };
    var reportContent = function () {
        if (module === "AOR_Reports") {
            return (_jsxs("div", __assign({ className: "relative" }, { children: [_jsx(ReportsChart, { id: record.id }), _jsx(ReportsList, { id: record.id })] })));
        }
        return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "flex flex-row" }, { children: _jsx("div", __assign({ className: "flex-[2]" }, { children: _jsx(LayoutComponentDisplay, { module: module, 
                        //key={module}
                        viewType: FieldViewType.DETAIL, fieldDefs: field_defs, record: editedRecord, fetchedRecord: record, layouts: (layoutMeta === null || layoutMeta === void 0 ? void 0 : layoutMeta.layout) || [], onHandleUpdate: updateRecord, 
                        //validations={new Map()}
                        validations: validations, viewScreen: screenViewType.DETAILVIEW }, "layout-".concat(formVersion)) })) })) }));
    };
    var _o = useState(false), isDeleteHovering = _o[0], setIsDeleteHovering = _o[1];
    var _p = useState(false), isEditHovering = _p[0], setIsEditHovering = _p[1];
    var _q = useState(false), isSaveHovering = _q[0], setIsSaveHovering = _q[1];
    var _r = useState(false), isUndoHovering = _r[0], setIsUndoHovering = _r[1];
    var _s = useState(false), isSendHovering = _s[0], setIsSendHovering = _s[1];
    var handleSendMouseOver = function () {
        setIsSendHovering(true);
    };
    var handleSendMouseOut = function () {
        setIsSendHovering(false);
    };
    var handleSaveMouseOver = function () {
        setIsSaveHovering(true);
    };
    var handleSaveMouseOut = function () {
        setIsSaveHovering(false);
    };
    var handleUndoMouseOver = function () {
        setIsUndoHovering(true);
    };
    var handleUndoMouseOut = function () {
        setIsUndoHovering(false);
    };
    var handleEditMouseOver = function () {
        setIsEditHovering(true);
    };
    var handleEditMouseOut = function () {
        setIsEditHovering(false);
    };
    var handleDeleteMouseOver = function () {
        setIsDeleteHovering(true);
    };
    var handleDeleteMouseOut = function () {
        setIsDeleteHovering(false);
    };
    var deleteRecordsMutaion = useDeleteRecordsMutation()[0];
    var deleteRecords = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setIsLoad(true);
                    return [4 /*yield*/, deleteRecordsMutaion({
                            moduleName: module,
                            body: record.id ? [record.id] : [],
                        }).unwrap()];
                case 1:
                    result = _a.sent();
                    navigate("/modules/".concat(module));
                    toast.success("Enregistrements supprimés");
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    setIsLoad(false);
                    console.log(error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var isEmptyValue = function (value) {
        if (value === null || value === undefined || value === "")
            return true;
        if (Array.isArray(value) && value.length === 0)
            return true;
        if (typeof value === "object" &&
            !Array.isArray(value) &&
            Object.keys(value).length === 0)
            return true;
        return false;
    };
    var normalize = function (obj, keys) {
        var clean = {};
        keys.forEach(function (key) {
            var value = obj === null || obj === void 0 ? void 0 : obj[key];
            if (isEmptyValue(value)) {
                clean[key] = "";
            }
            else if (typeof value === "number") {
                clean[key] = String(value);
            }
            else {
                clean[key] = value;
            }
        });
        return clean;
    };
    var hasChanges = useMemo(function () {
        var allKeys = Array.from(new Set(__spreadArray(__spreadArray([], Object.keys(baseRecord || {}), true), Object.keys(editedRecord || {}), true)));
        var a = normalize(baseRecord, allKeys);
        var b = normalize(editedRecord, allKeys);
        var diff = allKeys.filter(function (k) { return !isEqual(a[k], b[k]); });
        return diff.length > 0;
    }, [baseRecord, editedRecord]);
    var _t = useGetModuleBuilderLayoutListWidgetsQuery({
        moduleName: module,
        params: {
            layout: "detailviewdefs",
        },
    }), detail_widgetModule = _t.data, isLoadingWidgets = _t.isLoading;
    var _u = useState([]), widgetModuleDetailFromLayout = _u[0], setWidgetModuleDetailFromLayout = _u[1];
    var getModuleDetailWidgets = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if ((_a = detail_widgetModule === null || detail_widgetModule === void 0 ? void 0 : detail_widgetModule.data) === null || _a === void 0 ? void 0 : _a.listwidgets) {
                setWidgetModuleDetailFromLayout((_b = detail_widgetModule === null || detail_widgetModule === void 0 ? void 0 : detail_widgetModule.data) === null || _b === void 0 ? void 0 : _b.listwidgets);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        getModuleDetailWidgets();
    }, [detail_widgetModule]);
    var widgetDetail = useMemo(function () {
        return widgetModuleDetailFromLayout.map(function (widget) { return (_jsx("div", __assign({ className: "w-full rounded-[var(--border-widget)] mt-[var(--margin-mt-widget)] mr-[var(--margin-mr-widget)] mb-[var(--margin-mb-widget)] ml-[var(--margin-ml-widget)]" }, { children: _jsx(WidgetDisplay, { widget: widget }, widget.id) }))); });
    }, [widgetModuleDetailFromLayout]);
    //POPUP CONFIRMATION SUPPRESSION RECORD
    var _v = usePopup(), showPopup = _v.showPopup, closePopup = _v.closePopup;
    var deleteConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, showPopup({
                        type: "dev/popup/confirm",
                        payload: {
                            title: t("app.LBL_DELETE_CONFIRM") ||
                                "Voulez-vous vraiment supprimer cet enregistrement ?",
                            content: " ",
                            buttons: {
                                confirm: t("app.LBL_MASSUPDATE_DELETE_YES"),
                                cancel: t("app.LBL_MASSUPDATE_DELETE_NO"),
                            },
                        },
                    })];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 ? void 0 : result.reason) === "confirm") {
                        deleteRecords();
                        closePopup("null", "null");
                    }
                    else {
                        closePopup("null", "null");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "relative border bg-[#f4f4ff] dark:bg-gray-400 p-2 border-none\n        rounded-tl-[var(--border-detail-title-topLeft)] rounded-tr-[var(--border-detail-title-topRight)]\n        mt-8\n        mr-[var(--margin-mr-detail-view-fiche)]\n        ml-[var(--margin-ml-detail-view-fiche)]" // mt-[var(--margin-mt-detail-view-fiche)]
                , id: elemId }, { children: [validations.size > 0 && (_jsxs("div", __assign({ className: "bg-[rgb(var(--color-red-400))] p-3 m-2 rounded-md" }, { children: [_jsx("span", __assign({ className: "text-white p-5 text-sm font-medium" }, { children: "Le formulaire contient des erreurs." })), _jsx("ul", __assign({ className: "px-5 text-sm text-white font-medium" }, { children: Array.from(validations).map(function (_a) {
                                    var _b;
                                    var key = _a[0], value = _a[1];
                                    return (_jsxs("li", { children: [t((_b = filteredFieldsDefs[key]) === null || _b === void 0 ? void 0 : _b.vname, { ns: module }), _jsx("span", __assign({ className: "p-1" }, { children: value }))] }, key));
                                }) }))] }))), _jsx("div", __assign({ className: "flex" }, { children: _jsx("div", __assign({ className: "flex flex-col" }, { children: _jsxs("div", __assign({ className: "bg-[var(--colors-widget)] flex flex-row ml-4 mt-6 p-2" }, { children: [_jsx("h1", __assign({ className: "uppercase text-[var(--colors-label)] p-1" }, { children: record.name })), !isPreview && (_jsx("span", __assign({ onClick: toggleFavorite }, { children: _jsx(FontAwesomeIcon, { icon: faStar, className: "ml-2 cursor-pointer mt-2 ".concat(favoriteFlag ? "text-gray-800" : "text-gray-300") }) }))), _jsxs("div", __assign({ className: "ml-10 space-x-4" }, { children: [hasChanges && (_jsxs(_Fragment, { children: [_jsxs("button", __assign({ className: "hover:bg-red-500 text-red-500 font-bold hover:text-white rounded-md p-1", onMouseOver: handleSaveMouseOver, onMouseOut: handleSaveMouseOut, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                            var success;
                                                            return __generator(this, function (_a) {
                                                                switch (_a.label) {
                                                                    case 0: return [4 /*yield*/, saveRecord()];
                                                                    case 1:
                                                                        success = _a.sent();
                                                                        if (success) {
                                                                            commitChanges === null || commitChanges === void 0 ? void 0 : commitChanges();
                                                                        }
                                                                        return [2 /*return*/];
                                                                }
                                                            });
                                                        }); } }, { children: [_jsx(FontAwesomeIcon, { icon: faFloppyDisk, className: "px-2" }), isSaveHovering && (_jsx("label", __assign({ className: "text-white px-2" }, { children: String(t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" })) })))] })), _jsxs("button", __assign({ className: "hover:bg-red-500 text-red-500 font-bold hover:text-white rounded-md p-1", onMouseOver: handleUndoMouseOver, onMouseOut: handleUndoMouseOut, onClick: function () {
                                                            handleRollback();
                                                        } }, { children: [_jsx(FontAwesomeIcon, { icon: faUndo, className: "px-2" }), isUndoHovering && (_jsx("label", __assign({ className: "text-white px-2" }, { children: String(t("app.LBL_CANCEL_BUTTON_LABEL", { ns: "common" })) })))] }))] })), _jsxs("button", __assign({ className: "hover:bg-gray-300 font-bold rounded-md p-1", onMouseOver: handleEditMouseOver, onMouseOut: handleEditMouseOut, onClick: function () {
                                                    navigate("/modules/".concat(module, "/EditView/").concat(record.id));
                                                } }, { children: [_jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400 hover:text-white hover:bg-gray-300  px-2 dark:text-black" }), isEditHovering && (_jsx("label", __assign({ className: "text-white px-2" }, { children: String(t("app.LBL_EDIT_MODE", { ns: "common" })) })))] })), _jsxs("button", __assign({ className: "hover:bg-gray-300 font-bold rounded-md p-1", onMouseOver: handleDeleteMouseOver, onMouseOut: handleDeleteMouseOut, onClick: function () {
                                                    deleteConfirm();
                                                } }, { children: [_jsx(FontAwesomeIcon, { icon: faTrash, className: "text-gray-400 hover:text-white px-2 dark:text-black" }), isDeleteHovering && (_jsx("label", __assign({ className: "text-white px-1" }, { children: String(t("app.LBL_DELETE_BUTTON", { ns: "common" })) })))] })), (module === "Meetings" || module === "Calls") && (_jsxs("button", __assign({ className: "hover:bg-gray-300 font-bold rounded-md p-1", onMouseOver: handleSendMouseOver, onMouseOut: handleSendMouseOut, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                    var success;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, saveRecord(1)];
                                                            case 1:
                                                                success = _a.sent();
                                                                if (success) {
                                                                    commitChanges === null || commitChanges === void 0 ? void 0 : commitChanges();
                                                                }
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); } }, { children: [_jsx(FontAwesomeIcon, { icon: faPaperPlaneTop, className: "text-gray-400 hover:text-white hover:bg-gray-300  px-2 dark:text-black" }), isSendHovering && (_jsx("label", __assign({ className: "text-white px-2" }, { children: String(t("LBL_SEND_INVITES", { ns: "Home" })) })))] })))] }))] })) })) })), isLoad && _jsx(LoaderImage, {})] })), _jsx("div", __assign({ className: "bg-[#f4f4ff] dark:bg-gray-400  border-none\n        mr-[var(--margin-mr-detail-view-fiche)]\n        ml-[var(--margin-ml-detail-view-fiche)]" }, { children: _jsx("div", __assign({ className: "flex  px-5 text-sm text-[rgb(var(--color-gray-500))] relative" }, { children: widgetModuleDetailFromLayout.length > 0 && (_jsx("div", __assign({ className: "flex overflow-x-auto w-full relative widgets gap-3" }, { children: widgetDetail }))) })) })), _jsx("div", __assign({ className: "" }, { children: reportContent() })), (record === null || record === void 0 ? void 0 : record.id) && !isPreview && (_jsx("div", __assign({ id: "subpanels-".concat(record.id), className: "bg-[var(--colors-subpanel-bg)] ".concat(borderRadiusSubpanel, " overflow-hidden\n          mt-[var(--margin-mt-subpanel)] mr-[var(--margin-mr-subpanel)]\n          mb-[var(--margin-mb-subpanel)] ml-[var(--margin-ml-subpanel)]") }, { children: _jsx(Subpanels, { moduleName: module, record: record }) })))] }));
});
// Fonction de comparaison typée pour memo
var areEqual = function (prevProps, nextProps) {
    var _a, _b;
    return (prevProps.widget.id === nextProps.widget.id &&
        prevProps.widget.payload.module === nextProps.widget.payload.module &&
        ((_a = prevProps.widget.payload.record) === null || _a === void 0 ? void 0 : _a.id) === ((_b = nextProps.widget.payload.record) === null || _b === void 0 ? void 0 : _b.id));
};
export default memo(ModuleDetail, areEqual);
// Enregistrement du widget
widgetsDictionary.register("widget/module/detail", {
    name: "Module Detail",
    display: ModuleDetail,
    selectable: false,
});
